<template>
  <div class="container">
    <!-- <div class="banner " >
      <div class="swiper-container" style="height:480px;">
        <swiper
          :options="swiperOptions"
          ref="mySwiper"
          v-if="banner_list.length"
        >
          <swiper-slide
            v-for="(item, index) in banner_list"
            :key="index"
            @click="onSwiperClick(item)"
          >
            <img :src="item.image" class="swiper-img" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div> -->
    <div class="search-container flex align-center justify-between">
        <div class="type-box">
          <div :class="['type-item',{active:type == 'fabric'}]" @click="type = 'fabric'">
             <div class="type-icon-fabric"></div>
            <div class="type-text">面料库</div>
          </div>
          <div :class="['type-item',{active:type == 'accessory'}]" @click="type = 'accessory'">
            <div class="type-icon-accessory"></div>
            <div class="type-text">辅料库</div>
          </div>
        </div>

      <div class="text-filter flex align-center justify-between">
        <img
          src="../../assets/images/fabricHall/search-icon.png"
          style="width: 28px; height: 28px; margin-left: 20px"
        />
        <input
          placeholder="请输入关键词进行搜索"
          class="search-input"
          v-model="keyword"
          @keyup.enter="onSearch"
        />
        <button class="search-submit" @click="onSearch">搜索</button>
      </div>
    </div>
    <div class="category-list">
      <div
        class="category-item flex align-center flex-direction justify-center"
        v-for="(item, index) in category_list"
        :key="index"
        v-if="index <= 9"
        @click="clickCategory(item)"
      >
        <div class="image-box">
          <img
            :src="item.main_image|default_img"
            class="main-image"
          />
        </div>
        <div class="category-name">{{ item.category_name }}</div>
      </div>
      <div
        class="category-item flex align-center flex-direction justify-center" @click="goFabricHallSearch()">
        <div class="image-box">
          <img
            src="../../assets/images/fabricHall/all-fabric-icon.png"
            class="main-image"

          />
        </div>
        <div class="category-name"  >查看全部{{ type == 'fabric'?'面料':'辅料' }}</div>
      </div>
    </div>
    <div class="content-box">
      <div class="flex align-center justify-between">
        <div class="flex align-center">
          <b class="stick"></b>
          <span class="title">精品推荐</span>
        </div>
        <div class="flex align-center pointer" @click="goFabricHallSearch()">
          <span class="more">查看更多</span>
          <img
            src="../../assets/images/fabricHall/ico_more@2x.png"
            style="width: 14px; height: 14px; margin-left: 8px"
          />
        </div>
      </div>
      <div class="content-list flex flex-wrap align-center">
        <div class="content-item" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
          <!-- <img class="image" :src="item.image|default_img(false)" /> -->
          <div 
            class="image-box" 
            :style="{ backgroundImage: `url(${getLowQualityImage(item.image)})` }"
          ></div>
          <div class="fabric-name" :title="type == 'fabric' ? (item.fabric_name_cn || item.goods_no):item.accessory_name">{{ type == 'fabric' ? (item.fabric_name_cn || item.goods_no):item.accessory_name  }}</div>
          <!-- <div class="fabric-code">{{ type == 'fabric'?'面料':'辅料' }}编号：{{ item.fabric_key }}</div> -->
          <div v-if="type == 'fabric'" class="fabric-code" :title="item.component">成份：{{ item.component || '-' }}</div>
          <div v-else class="fabric-code">辅料编号：{{ item.accessory_sku || '-' }}</div>
          <div class="fabric-price" v-if="item.fabric_price>0">¥{{ item.fabric_price }}起</div>
          <div class="fabric-price" v-else>咨询客服</div>
        </div>
      </div>
      <div class="show-more" @click="goFabricHallSearch()">
        <div class="flex align-center justify-center">
          <span class="more-text">查看更多{{ type == 'fabric'?'面料':'辅料' }}</span>
          <img
            src="../../assets/images/fabricHall/ico_more@2x.png"
            style="width: 14px; height: 14px; margin-left: 8px"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  AccessoryCategoryList,
  AccessoryList,
  FabricCategoryList,
  FabricList,
  GetBannerList,
} from "@/api";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      swiperOptions: {
        // 核心配置
        slidesPerView: 1, // 每页显示 1 张幻灯片
        centeredSlides: true, // 当前幻灯片居中显示
        spaceBetween: 10, // 幻灯片间距
        loop: true, // 启用循环模式
        loopedSlides: 0,
        grabCursor: true, // 拖动时显示抓手光标
        autoplay: {
          delay: 3000, // 3秒切换
          disableOnInteraction: false, // 手动滑动后继续自动播放
        },

        pagination: {
          el: ".swiper-pagination", // 指定分页器容器选择器
          type: "bullets", // 类型：bullets（圆点）、fraction（分数）、progress（进度条）等
          clickable: true, // 允许点击分页器切换幻灯片
          bulletActiveClass: "my-swiper-pagination-active", // 自定义激活状态类名
        },
      },
      banner_list: [],
      list: [],
      isBackToTopVisible: false,
      page: 1,
      limit: 9,
      total_count: 0,
      keyword: "",
      category_list: [],
      type: "fabric",
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  filters: {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("changeFooter", "light");
    });
  },
  mounted() {
    const type = localStorage.getItem('fabricHallType');
    if(type) this.type = type;
    this.onGetBannerList();
    this.onFabricCategoryList();
    this.onFabricList();
  },
  beforeDestroy() {},
  watch: {
    type() {
      this.onFabricCategoryList();
      this.onFabricList();
    },
  },
  methods: {
    getLowQualityImage(imageUrl) {
      if (!imageUrl) return this.$options.filters.default_img('', false);

      // 使用OSS图片处理服务生成低质量版本
      // 这里使用缩放和质量参数来生成低质量版本
      return `${imageUrl}?x-oss-process=image/resize,m_lfit,w_500,h_500/quality,q_80/format,webp`;
    },
    clickCategory(item) {
      if (this.type == "fabric") {
        this.$router.push({
          name: "FabricHallSearch",
          params: { category_id: item.fabric_category_id, category_name: item.category_name, type: this.type },
        });
      } else {
        this.$router.push({
          name: "FabricHallSearch",
          params: { category_id: item.accessory_category_id, category_name: item.category_name, type: this.type },
        });
      }
    },
    goFabricHallSearch() {
      this.$router.push({
        name: "FabricHallSearch",
        params: { type: this.type },
      });
    },
    async onFabricList() {
      this.list = [];
      if (this.type == "fabric") {
        var { data } = await FabricList({
          page: 1,
          size: 35,
        });
      } else {
        var { data } = await AccessoryList({
          page: 1,
          size: 35,
        });
      }
      this.list = data.list;
      if(localStorage.getItem('fabricHallType')){
        localStorage.removeItem('fabricHallType');
      }
    },
    async onFabricCategoryList() {
      this.category_list = [];
      if (this.type == "fabric") {
        var { data } = await FabricCategoryList();
      } else {
        var { data } = await AccessoryCategoryList();
      }
      this.category_list = data;
    },

    onSearch() {
      this.$router.push({
        name: "FabricHallSearch",
        params: { keyword: this.keyword, type: this.type },
      });
    },
    goDetail(item) {
      localStorage.setItem('fabricHallType',this.type);
      // this.$router.push({
      //   name: "FabricHallDetail",
      //   query: { id: item.id, type: this.type },
      // });
      let route = this.$router.resolve({ name: "FabricHallDetail", query: { id: item.id, type: this.type }, })
      window.open(route.href, '_blank')
    },
    async onGetBannerList() {
      try {
        const param = {};
        param.position = 7;
        const { data } = await GetBannerList(param);
        this.swiperOptions.loopedSlides = data.length;
        this.banner_list = data;
      } catch (e) {
        console.log("e-banner", e);
      }
    },
    onSwiperClick({ url }) {
      console.log("轮播点击", url);
      if (!url) return;
      if (url.startsWith("http")) {
        // window.location.href = url;
        window.open(url, "_blank");
      } else {
        this.$router.push(url);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container{
  // width:100vw;
  width:100%;
  min-height:100%;
  .search-container {
    padding: 32px 100px;
    background: #F8F9FB;
    display:flex;
    justify-content:space-between;
    align-items:center;
    column-gap:145px;
    .type-filter {
      width: 220px;
      height: 56px;
      background: #efedf0;
      border-radius: 28px;
      padding: 0 46px;
      cursor: pointer;
      .type-name {
        margin-left: 5px;
        font-size: 18px;
        color: #000000;
      }
    }
    .type-box{
      display:flex;
      align-items:center;
      column-gap:16px;
      .type-item{
        width:220px;
        height:56px;
        background:#ffffff;
        border:1px solid #e3e3e3;
        border-radius:10px;
        display:flex;
        align-items:center;
        justify-content:center;
        column-gap:6px;
        cursor:pointer;
        .type-icon-fabric{
          background:url('../../assets/images/icon-hall-fabric.png');
        }
        .type-icon-accessory{
          background:url('../../assets/images/icon-hall-accessory.png');
        }
        .type-icon-fabric, .type-icon-accessory{
          width:28px;
          height:28px;
          background-size:cover;
          background-position:center;
          background-repeat:no-repeat;
        }
        .type-text{
          color:#000000;
          font-size:18px;
        }
        &.active, &:hover{
          background:#1c1f23;
          border:none;
          .type-icon-fabric{
            background:url('../../assets/images/icon-hall-fabric-active.png');
          }
          .type-icon-accessory{
            background:url('../../assets/images/icon-hall-accessory-active.png');
          }
          .type-icon-fabric, .type-icon-accessory{
            width:28px;
            height:28px;
            background-size:cover;
            background-position:center;
            background-repeat:no-repeat;
          }
          .type-text{
            color:#ffffff;
          }
        }
      }
    }
    .text-filter {
      flex: 1;
      height: 56px;
      background: #ffffff;
      border-radius: 5px;
      border: 1px solid #d8d7d9;
      // margin-left: 60px;
      .search-input {
        flex: 1;
        border: none !important;
        background: transparent;
        height: 100%;
        padding-left: 25px;
        padding-right: 5px;
        outline: none !important;
      }
      .search-submit {
        width: 120px;
        height: 46px;
        background: #ff5967;
        border-radius: 5px;
        line-height: 46px;
        text-align: center;
        color: #ffffff;
        margin-right: 5px;
        border: none;
      }
    }
  }
  .category-list {
    padding: 24px 100px;
    margin: 0 auto;
    display: flex;
    background: #ffffff;
    .category-item {
      width: 138px;
      height: 150px;
      background: #f8f6f9;
      margin-right: 20px;
      &:last-child{
        margin-right:0;
      }
      cursor: pointer;
      .image-box {
        width: 76px;
        height: 76px;
        margin-bottom: 6px;
        .main-image {
          width: 100%;
          height: 100%;
        }
      }
      .category-name {
        font-size: 16px;
        line-height: 24px;
        color: #424242;
        text-align: center;
      }
    }
  }
  .content-box {
    padding: 24px 100px 53px 100px;
    background: #F8F9FB;
    .stick {
      width: 4px;
      height: 28px;
      background: #FF5967;
      border-radius: 2px 2px 2px 2px;
    }
    .title {
      margin-left: 12px;
      font-weight: 500;
      font-size: 22px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .more {
      cursor: pointer;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      text-align: right;
      font-style: normal;
      text-transform: none;
    }
    .content-list {
      margin-top: 36px;
      display:flex;
      gap:20px;
      .content-item {
        // width: 220px;
        width:calc(100% / 7 - 17.5px);
        height: 320px;
        background: #ffffff;
        padding: 10px;
        cursor:pointer;
        display:flex;
        flex-direction:column;
        align-items:center;
        &:hover{
          box-shadow: 0px 0px 7px 0px #D4D4D4;
        }
        .image {
          // width: 200px;
          width:100%;
          height: 208px;
          object-fit:contain;
        }
        .image-box {
          width: 100%;
          aspect-ratio: 1 / 1; 
          
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #ffffff;
          
          transform: translateZ(0);
          backface-visibility: hidden;
          
          transition: transform 0.3s ease;
          
        }
        .fabric-name {
          font-size: 16px;
          line-height: 24px;
          color: #1a1a1a;
          margin-top: 8px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          text-align:left;
          width:100%;
        }
        .fabric-code {
          font-size: 14px;
          line-height: 21px;
          color: #808080;
          margin-top: 2px;
          text-align:left;
          width:100%;
          white-space:nowrap;
          text-overflow:ellipsis;
          overflow:hidden;
        }
        .fabric-price {
          font-size: 16px;
          line-height: 24px;
          color: #e00000;
          margin-top: 6px;
          text-align:left;
          width:100%;
        }
      }
    }
    .show-more {
      margin: 72px auto;
      width: 200px;
      height: 56px;
      line-height: 56px;
      // background: #f8f6f9;
      border-radius: 28px 28px 28px 28px;
      border: 1px solid #e3e3e3;
      text-align: center;
      cursor: pointer;
      .more-text {
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }
  .creator-box {
    background: #ffffff;
    border-radius: 15px;
    font-size: 16px;
    text-align: center;
    margin: 10px 5px;
    .item-box {
      .menu-item {
        height: 45px;
        line-height: 45px;
        color: #000000;
        cursor: pointer;
        text-align: center;

        &:hover {
          border-radius: 10px;
          background: #ff5967;
          color: #ffffff;
        }
      }
    }
  }
}

@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .container {
    transform: scale(0.95); // 缩小到原来的95%
    transform-origin: top left; // 设置缩放原点为左上角
    width: calc(100vw / 0.95); //宽度补齐
  }
}

@media screen and (max-width: 1279px) {
  .container {
    transform: scale(0.85); // 缩小到原来的85%
    transform-origin: top left; // 设置缩放原点为左上角
    width:calc(100% / 0.85); //宽度补齐
  }
}
</style>
